import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { Asignacion } from '../shared/models/asignacion';
import { Solicitud } from '../shared/models/solicitud';
import { DireccionIp } from '../shared/models/direccion-ip';
import { TipoAsignacion } from '../shared/models/tipo-asignacion';
import { AsignacionManualDto } from '../shared/models/asignacion-manual-dto';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { TipoAsignacionService } from '../shared/services/tipo-asignacion.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { environment } from '../../environments/environment';
import { ErrorDto } from '../shared/models/error-dto';
import { AsignacionManualSedeDto } from '../shared/models/asignacion-manual-sede-dto';
import { AsignacionService } from '../shared/services/asignacion.service';
import { AsignacionSedeDto } from '../shared/models/asignacion-sede-dto';
import { Sesion } from '../shared/models/sesion';

@Component({
  selector: 'app-asignacion-manual-sede',
  templateUrl: './asignacion-manual-sede.component.html',
  styleUrls: ['./asignacion-manual-sede.component.css']
})
export class AsignacionManualSedeComponent implements OnInit {
  modalAgregarFormGoup = this.formBuilder.group({
    urlControl: [''],
    servidorControl: ['', Validators.required],
    servicioControl: ['', Validators.required],
    plataformaControl: ['', Validators.required],
    rolControl: ['', Validators.required],
    controlObeservaciones: new FormControl(),
    controlDns: new FormControl(),
    checkDns: new FormControl()
  });

  private asignacionManual = environment.tipoAsignacionManual;
  private codigoListaAmbientes = environment.listaCodigoAmbientes;
  private codigoListaEquipos = environment.listaCodigoEquipos;
  private codigoListaServicio = environment.listaCodigoServicio;
  private codigoListaPlataforma = environment.listaCodigoPlataforma;
  private codigoListaRol = environment.listaCodigoRol;
  private codigoAmbienteSedes = environment.listaItemAmbienteSedes;

  companias: Compania[];
  companiaSeleccionada: Compania = new Compania();
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  idCompaniaSeleccionada = -1;
  idCiudadSeleccionada = -1;
  idSedeSeleccionada = -1;
  idAmbienteSelecccionado = -1;
  idVlanSeleccionado = -1;
  ambientes: ListaItem[];
  tiposAsignacion: TipoAsignacion[];
  idTipoAsignacionSeleccionado: number;
  tipoasignacionSeleccionado: TipoAsignacion;
  ListaDirecciones: AsignacionManualSedeDto[] = new Array<AsignacionManualSedeDto>();
  direccionIpSeleccionada: AsignacionManualSedeDto = new AsignacionManualSedeDto();
  asignacionEditar: Asignacion = new Asignacion();
  direccionIp = '';
  modalRef: NgbModalRef;
  servidores: ListaItem[];
  servidoresFiltrados: ListaItem[];
  servidorSeleccionado: ListaItem;
  servicios: ListaItem[];
  serviciosFiltrados: ListaItem[];
  servicioSeleccionado: ListaItem;
  plataformas: ListaItem[];
  plataformaFiltradas: ListaItem[];
  plataformaSeleccionado: ListaItem;
  roles: ListaItem[];
  rolesFiltrados: ListaItem[];
  rolSeleccionado: ListaItem;
  observaciones: string;
  dns = '';
  agregarActivo = false;
  agregarDns = false;
  permisoUsuario = true;
  permisoAdminCeco = true;
  solicitudSeleccionada: Solicitud = new Solicitud();
  indexSeleccionado: number;
  mensajeAlerta: string;
  permiso: boolean;
  error: ErrorDto;
  sesion: Sesion = new Sesion();
  @ViewChild('alertaModal') alertaModalRef: ElementRef;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private tipoAsignacionService: TipoAsignacionService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService, private asignacionService: AsignacionService) { }

  ngOnInit() {
    this.listaItemService.listaItemPorCodigos(this.codigoAmbienteSedes, this.codigoListaAmbientes).subscribe(
      resultado => this.idAmbienteSelecccionado = resultado.idListaItem
    );
    this.listarCompanias();
    this.listarTiposAsignacion();
    this.cargarListasDialogo();
    this.buscarTipoAsignacionManual();
    this.cargarDatosSession();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public buscarTipoAsignacionManual(): void {
    this.tipoAsignacionService.tipoAsignacionPorNombre(this.asignacionManual).subscribe(
      resultado => {
        this.tipoasignacionSeleccionado = resultado;
        if (this.tipoasignacionSeleccionado == null) {
          this.mensajeAlerta = 'No se ha configurado el tipo de asignacion manual, contacte al administrador';
          this.modalRef = this.modalService.open(this.alertaModalRef, { size: 'lg' });
        } else {
          this.idTipoAsignacionSeleccionado = this.tipoasignacionSeleccionado.idTipoAsignacion;
        }

      }
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.ListaDirecciones = new Array<AsignacionManualSedeDto>();
    this.seleccionarCompania();
    this.idCiudadSeleccionada = -1;
    this.idSedeSeleccionada = -1;
    this.idVlanSeleccionado = -1;
    this.ciudades = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaSeleccionada).subscribe(
      resultado => {
        this.ciudades = resultado
        if (this.permisoUsuario) {
          this.ciudades = this.ciudades.filter(item => !item.nombreCiudad.includes('CLOUD'));
        }
      }
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.ListaDirecciones = new Array<AsignacionManualSedeDto>();
    this.idSedeSeleccionada = -1;
    this.idVlanSeleccionado = -1;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => {
        this.sedes = resultado

        if (this.permisoUsuario) {
          this.sedes = this.sedes.filter(item => !item.nombreSede.includes('CENTRO DE COMPUTO IBM'));
          this.sedes = this.sedes.filter(item => !item.nombreSede.includes('CENTRO DE COMPUTO TORRE SURAMERICANA'));
        }
      }
    );
  }

  public listarVlanPorSedeAmbienteCompania(): void {
    this.ListaDirecciones = new Array<AsignacionManualSedeDto>();
    this.idVlanSeleccionado = -1;
    this.vlans = null;
    this.vlanService.vlansPorSedeAmbienteCompania(this.idSedeSeleccionada,
      this.idAmbienteSelecccionado, this.idCompaniaSeleccionada, false).subscribe(
        resultado => {

          this.vlans = resultado
          if (this.permisoUsuario) {
            this.vlans = this.vlans.filter(item => !item.nombreVlan.includes('VLAN TELCO'));
          }
          if (this.permisoAdminCeco) {
            this.vlans = this.vlans.filter(item => !item.nombreVlan.includes('VLAN TELCO'));
          }
        });
  }

  public listarTiposAsignacion(): void {
    this.tiposAsignacion = null;
    this.tipoAsignacionService.listarTiposAsignacion().subscribe(
      resultado => this.tiposAsignacion = resultado
    );
  }

  public buscarDirecciones(cargandoModal): void {
    if (this.idVlanSeleccionado != null) {
      this.modalRef = this.modalService.open(cargandoModal, { size: 'sm' });
      let direccion: string;
      if (this.direccionIp.length <= 0) {
        direccion = '-1';
      } else {
        direccion = this.direccionIp;
      }
      this.administradorIpService.consultarDireccionesIpAsignacionManualSede(this.idVlanSeleccionado, direccion).subscribe(
        resultado => {
          this.ListaDirecciones = resultado;
          this.modalRef.close();
        }
      );
    }
  }

  cargarListasDialogo() {
    this.ListarServidor();
    this.ListarServicio();
    this.ListarPlataformas();
    this.ListarRoles();
  }

  public ListarServidor(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaEquipos).subscribe(
      resultado => this.servidores = resultado
    );
  }

  public ListarServicio(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServicio).subscribe(
      resultado => this.servicios = resultado
    );
  }

  public ListarPlataformas(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaPlataforma).subscribe(
      resultado => this.plataformas = resultado
    );
  }

  public ListarRoles(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaRol).subscribe(
      resultado => this.roles = resultado
    );
  }

  // Filtra los valores para el autocomplete
  public async filterRol(event) {
    this.rolesFiltrados = [];
    for (let i = 0; i < this.roles.length; i++) {
      const rol = this.roles[i];
      if (rol.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.rolesFiltrados.push(rol);
      }
    }
    if (this.rolesFiltrados.length == 1 &&
      event.query.toUpperCase() == this.rolesFiltrados[0].valorItem) {
      this.rolSeleccionado = this.rolesFiltrados[0];
    } else {
      const rolNuevo: ListaItem = new ListaItem();
      rolNuevo.indicadorHabilitado = true;
      rolNuevo.lista = this.roles[0].lista;
      rolNuevo.codigoItem = await this.ultimoCodigoDeLista(rolNuevo.lista.idLista);
      rolNuevo.valorItem = event.query;
      rolNuevo.idListaItem = null;
      this.rolSeleccionado = rolNuevo;
    }
  }

  // Filtra los valores para el autocomplete
  public async filterPlataforma(event) {
    this.plataformaFiltradas = [];
    for (let i = 0; i < this.plataformas.length; i++) {
      const plataforma = this.plataformas[i];
      if (plataforma.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.plataformaFiltradas.push(plataforma);
      }
    }
    if (this.plataformaFiltradas.length == 1 &&
      event.query.toUpperCase() == this.plataformaFiltradas[0].valorItem) {
      this.plataformaSeleccionado = this.plataformaFiltradas[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.plataformas[0].lista;
      itemNuevo.codigoItem = await this.ultimoCodigoDeLista(itemNuevo.lista.idLista);
      itemNuevo.valorItem = event.query;
      itemNuevo.idListaItem = null;
      this.plataformaSeleccionado = itemNuevo;
    }
  }

  // Filtra los valores para el autocomplete
  public async filterServicio(event) {
    this.serviciosFiltrados = [];
    for (let i = 0; i < this.servicios.length; i++) {
      const servicio = this.servicios[i];
      if (servicio.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.serviciosFiltrados.push(servicio);
      }
    }
    if (this.serviciosFiltrados.length == 1 &&
      event.query.toUpperCase() == this.serviciosFiltrados[0].valorItem) {
      this.servicioSeleccionado = this.serviciosFiltrados[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.servicios[0].lista;
      itemNuevo.codigoItem = await this.ultimoCodigoDeLista(itemNuevo.lista.idLista);
      itemNuevo.valorItem = event.query;
      itemNuevo.idListaItem = null;
      this.servicioSeleccionado = itemNuevo;
    }
  }

  // Filtra los valores para el autocomplete
  public async filterServidor(event) {
    this.servidoresFiltrados = [];
    for (let i = 0; i < this.servidores.length; i++) {
      const servidor = this.servidores[i];
      if (servidor.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.servidoresFiltrados.push(servidor);
      }
    }
    if (this.servidoresFiltrados.length == 1 &&
      event.query.toUpperCase() == this.servidoresFiltrados[0].valorItem) {
      this.servidorSeleccionado = this.servidoresFiltrados[0];
    } else {
      const itemNuevo: ListaItem = new ListaItem();
      itemNuevo.indicadorHabilitado = true;
      itemNuevo.lista = this.servidores[0].lista;
      itemNuevo.codigoItem = await this.ultimoCodigoDeLista(itemNuevo.lista.idLista);
      console.log(itemNuevo.codigoItem);
      itemNuevo.valorItem = event.query;
      itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
      itemNuevo.idListaItem = null;
      this.servidorSeleccionado = itemNuevo;
    }
  }

  // Metodo que limpia la lista de ip's al cambiar de vlan seleccionada
  public onChangeVlan(): void {
    this.ListaDirecciones = new Array<AsignacionManualSedeDto>();
  }

  public async abrirDialogoAsignar(direccion: AsignacionManualSedeDto, ediatrModal) {
    this.indexSeleccionado = this.ListaDirecciones.indexOf(direccion);
    this.direccionIpSeleccionada = this.ListaDirecciones[this.indexSeleccionado];
    this.limpiarDialogo();
    if (!this.direccionIpSeleccionada.disponible) {
      this.asignacionEditar = await this.asignacionService.
        asignacionActivaDeDireccionAsync(this.direccionIpSeleccionada.asignacionAcual.idDireccionIp);
      this.cargarValoresDialogo();
    }
    this.modalRef = this.modalService.open(ediatrModal, { size: 'lg' });
  }

  public limpiarDialogo(): void {
    this.servidorSeleccionado = null;
    this.servicioSeleccionado = null;
    this.plataformaSeleccionado = null;
    this.rolSeleccionado = null;
    this.solicitudSeleccionada = new Solicitud();
    this.solicitudSeleccionada.tipoAsignacion = new TipoAsignacion();
    this.agregarDns = false;
    this.dns = '';
    this.observaciones = '';
    this.agregarDns = false;
  }

  public cargarValoresDialogo() {
    if (this.asignacionEditar != null && this.asignacionEditar.idAsignacion != null) {
      if (this.asignacionEditar.nombreServidor != null) {
        this.servidorSeleccionado = this.asignacionEditar.nombreServidor;
      }
      if (this.asignacionEditar.servicioITNegocio != null) {
        this.servicioSeleccionado = this.asignacionEditar.servicioITNegocio;
      }
      if (this.asignacionEditar.plataforma != null) {
        this.plataformaSeleccionado = this.asignacionEditar.plataforma;
      }
      if (this.asignacionEditar.funcion != null) {
        this.rolSeleccionado = this.asignacionEditar.funcion;
      }
      this.observaciones = this.asignacionEditar.observaciones;
      this.agregarDns = this.asignacionEditar.indicadorDns;
      this.dns = this.asignacionEditar.configuracionDNS;
    }
  }

  public async setearAsignacion(cargandoModal, alertaModal) {
    this.modalRef.close();
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    await this.setearListas();
    this.direccionIpSeleccionada.asignacionEditada = new AsignacionSedeDto();
    this.direccionIpSeleccionada.asignacionEditada.configuracionDns = this.dns;
    this.direccionIpSeleccionada.asignacionEditada.idCompania = this.idCompaniaSeleccionada;
    this.direccionIpSeleccionada.asignacionEditada.idDireccionIp = this.direccionIpSeleccionada.
      asignacionAcual.idDireccionIp;
    this.direccionIpSeleccionada.asignacionEditada.idListaEquipo = this.servidorSeleccionado.idListaItem;
    this.direccionIpSeleccionada.asignacionEditada.idListaServicio = this.servicioSeleccionado.idListaItem;
    this.direccionIpSeleccionada.asignacionEditada.idPlataforma = this.plataformaSeleccionado.idListaItem;
    this.direccionIpSeleccionada.asignacionEditada.idRol = this.rolSeleccionado.idListaItem;
    this.direccionIpSeleccionada.asignacionEditada.idTipoAsignacion = this.idTipoAsignacionSeleccionado;
    this.direccionIpSeleccionada.asignacionEditada.indiacdorHabilitado = true;
    this.direccionIpSeleccionada.asignacionEditada.observaciones = this.observaciones;
    console.log(this.direccionIpSeleccionada);
    this.administradorIpService.editarAsignacionSede(this.direccionIpSeleccionada).subscribe(
      resultado => {
        this.direccionIpSeleccionada = resultado;
        this.ListaDirecciones[this.indexSeleccionado] = this.direccionIpSeleccionada;
        this.modalRef.close();
        this.cargarListasDialogo();
      }, error => {
        this.modalRef.close();
        this.mensajeAlerta = 'Ocurrio un error al guardar la asignacion';
        this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
      }
    );
  }

  public async setearListas() {
    if (this.servidorSeleccionado.idListaItem == null && this.servidorSeleccionado.valorItem.length > 0) {
      await this.guardarListaItem(this.servidorSeleccionado).then(resultado => {
        this.servidorSeleccionado = resultado;
      });
    }
    if (this.plataformaSeleccionado.idListaItem == null && this.plataformaSeleccionado.valorItem.length > 0) {
      await this.guardarListaItem(this.plataformaSeleccionado).then(resultado => {
        this.plataformaSeleccionado = resultado;
      });
    }
    if (this.rolSeleccionado.idListaItem == null && this.rolSeleccionado.valorItem.length > 0) {
      await this.guardarListaItem(this.rolSeleccionado).then(resultado => {
        this.rolSeleccionado = resultado;
      });
    }
    if (this.servicioSeleccionado.idListaItem == null && this.servicioSeleccionado.valorItem.length > 0) {
      await this.guardarListaItem(this.servicioSeleccionado).then(resultado => {
        this.servicioSeleccionado = resultado;
      });
    }
  }

  // Guarda ListaItem
  public async guardarListaItem(listaItem: ListaItem): Promise<ListaItem> {
    let listaItemGuardado: ListaItem = new ListaItem();
    if (listaItem != null && listaItem.codigoItem != null && listaItem.valorItem != null) {
      listaItemGuardado = await this.listaItemService.guardarListaAsync(listaItem);
    }
    return listaItemGuardado;
  }

  public liberarIpSede(direccion: AsignacionManualSedeDto, cargandoModal) {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.indexSeleccionado = this.ListaDirecciones.indexOf(direccion);
    this.direccionIpSeleccionada = this.ListaDirecciones[this.indexSeleccionado];
    if (this.direccionIpSeleccionada.disponible == false) {
      this.administradorIpService.liberarIpSede(this.direccionIpSeleccionada).subscribe(
        resultado => {
          this.direccionIpSeleccionada = resultado;
          this.ListaDirecciones[this.indexSeleccionado] = this.direccionIpSeleccionada;
          this.modalRef.close();
        }
      );
    }
  }

  public async ultimoCodigoDeLista(idLista: number): Promise<string> {
    let ultimo: number = await this.listaItemService.maximoCodigoLista(idLista);
    ultimo = ultimo + 1;
    return ultimo.toString();
  }
  public cargarDatosSession(): void {
    this.sesionService.consultarDatosSesion().subscribe(
      resultado => {

        this.sesion = resultado
        if (this.sesion.permisoMenuDto.permisoAsignacionIpUsuario) {

          this.permisoUsuario = true;

        }
        else {
          this.permisoUsuario = true;
        }
        if (this.sesion.permisoMenuDto.permisoAsignacionIpAdminCeco) {

          this.permisoAdminCeco = true;

        }
        else {
          this.permisoAdminCeco = true;
        }
      })

  }
}



// WEBPACK FOOTER //
// ./src/app/asignacion-manual-sede/asignacion-manual-sede.component.ts